module.exports = __webpack_public_path__ + "static/media/photo2.209295e3.jpg";